import React, { useContext } from 'react';
import OrderContext from './OrderContext';
import { Accordion, Card } from 'react-bootstrap';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import AcceptedOrderLines from './accepted/AcceptedOrderLines';
import SubstitutionOrderLines from './issues/substitutions/SubstitutionOrderLines';
import { IconWrapper } from '../../common/IconWrapper';

export default function CompletedOrder({ orderLinesLoading }) {
    const { basket } = useContext(OrderContext);

    return (
        <>
            {basket.rejected.length > 0 && (
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <span>Not Delivered</span>
                            <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.rejected}
                                    loading={orderLinesLoading}
                                    disableEditing={true}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.alternatives.length > 0 && (
                <Accordion defaultActiveKey="2">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="2">
                            Alternatives <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <SubstitutionOrderLines
                                    orderLines={basket.alternatives}
                                    loading={orderLinesLoading}
                                    disableEditing={true}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.substitutes.length > 0 && (
                <Accordion defaultActiveKey="3">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="3">
                            Substitutions <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <SubstitutionOrderLines
                                    orderLines={basket.substitutes}
                                    loading={orderLinesLoading}
                                    disableEditing={true}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
            {basket.delivered.length > 0 && (
                <Accordion defaultActiveKey="4">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="4">
                            Delivered <IconWrapper icon={faChevronDown} />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <AcceptedOrderLines
                                    orderLines={basket.presell.concat(basket.delivered)}
                                    loading={orderLinesLoading}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
        </>
    );
}
